import { render, staticRenderFns } from "./DialogComponent.vue?vue&type=template&id=c4fc75f0&scoped=true"
import script from "./DialogComponent.vue?vue&type=script&lang=js"
export * from "./DialogComponent.vue?vue&type=script&lang=js"
import style0 from "./DialogComponent.vue?vue&type=style&index=0&id=c4fc75f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4fc75f0",
  null
  
)

export default component.exports